import React, { ChangeEvent, FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import { FaqEditorItemProps } from 'types/assist/faqEditor';

export const FaqEditorItem: FC<FaqEditorItemProps> = ({
  faq,
  faqIndex,
  items,
  isQuestionReadOnly,
  isRemovalAllowed,
  readOnlyQuestionLabel,
  readOnlyQuestionHelperText,
  onChange,
}) => {
  const handleQuestionChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextItems = items.map((item, itemIndex) => {
      return itemIndex === faqIndex ? { ...item, question: event.target.value } : item;
    });

    onChange(nextItems);
  };

  const handleAnswerChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextItems = items.map((item, itemIndex) => {
      return itemIndex === faqIndex ? { ...item, answer: event.target.value } : item;
    });

    onChange(nextItems);
  };

  const handleRemove = () => {
    onChange(items.filter((_, itemIndex) => itemIndex !== faqIndex));
  };

  const questionChangeHandler = isQuestionReadOnly ? undefined : handleQuestionChange;

  return (
    <Box
      sx={{
        mb: 0.75,
        p: isQuestionReadOnly ? 1 : 0,
        border: isQuestionReadOnly ? 1 : 0,
        borderColor: isQuestionReadOnly ? 'info.light' : 'transparent',
        borderRadius: 1,
        bgcolor: isQuestionReadOnly ? 'action.hover' : 'transparent',
      }}
    >
      {isQuestionReadOnly && (
        <Chip
          size="small"
          color="info"
          variant="outlined"
          label={readOnlyQuestionLabel}
          sx={{ mb: 0.75 }}
        />
      )}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <TextField
          size="small"
          label="Q"
          value={faq.question}
          fullWidth
          multiline
          helperText={isQuestionReadOnly ? readOnlyQuestionHelperText : undefined}
          slotProps={{ input: { readOnly: isQuestionReadOnly } }}
          onChange={questionChangeHandler}
        />
        <TextField
          size="small"
          label="A"
          value={faq.answer}
          fullWidth
          multiline
          onChange={handleAnswerChange}
        />
        {isRemovalAllowed && (
          <Button size="small" color="error" aria-label="Remove FAQ" onClick={handleRemove}>
            ×
          </Button>
        )}
      </Box>
    </Box>
  );
};
